import { useState } from "react";
import { PromptPair } from "./Wazawan";
import { selectUser } from "../../redux/features/appData";
import { useSelector } from "react-redux";
import { DCPreviewEmployeeRecord } from "../app/dynamic-components/DCPreviewEmployeeRecord";
import { Maximize2 } from "lucide-react";
import "./WazawanFormPreview.css";
import { NR_DELETE_THIS_EMPLOYEE_RECORD_ID } from "../app/dynamic-components/DCRouter";

type WazawanFormPreviewProps = {
    promptPair: PromptPair;
    onExpand: (promptPair: PromptPair) => void;
}

export const WazawanFormPreview = ({promptPair, onExpand} : WazawanFormPreviewProps) => {

    const storeUser = useSelector(selectUser)
    
    let response : any = {};
    try {
        response = JSON.parse(promptPair.response);
    } catch (e) {
        response = promptPair.response;
    }
    // const response = JSON.parse(promptPair.response);
    const object = response.object;
    const label = response.label;

    console.log("[WazawanFormPreview] promptPair.response: ", promptPair.response);

    return (
        <div 
            className="wazawan-form-preview"
        >
            {(() => {
                switch(object) {
                    case "employee-record":
                        return (
                            <DCPreviewEmployeeRecord 
                                id={NR_DELETE_THIS_EMPLOYEE_RECORD_ID || ""}
                                properties={[label]}
                            /> 
                        )
                    default:
                        return (
                            <>
                                Form preview for: {promptPair.response}
                            </>
                        )
                }
            })()
            }
            
            <div 
                className="wazawan-form-preview-expand"
                onClick={()=>onExpand(promptPair)}
            >
                <Maximize2 size={16} />
            </div>
        </div>        
    )
}